module.exports = __webpack_public_path__ + "static/106-015c3ea8a87a7b5c6cfb6d0e18056ecc.png";